import { observer } from "mobx-react-lite";
import { Box, Button, CircularProgress } from "@mui/material";
import { useStore } from "../../../api/main/appStore";
import * as Yup from "yup";
import { Form, Formik } from "formik";
import MyFormikController from "../../shared/forms/MyFormikController";
import { InvestmentTenureModel } from "../../../api/models/investmentTenure";

interface Props {
  investmentTenure: InvestmentTenureModel | null;
}

export default observer(function CreateOrUpdateInvestmentTenure({
  investmentTenure,
}: Props) {
  const { investmentTenureStore } = useStore();

  const initialValues = {
    id: investmentTenure?.id ?? "",
    tenure: investmentTenure?.tenure ?? 0,
  };

  const validationSchema = Yup.object({
    tenure: Yup.number().min(30, "Tenure must be at least 30 days"),
  });

  return (
    <Box>
      <Formik
        initialValues={initialValues}
        validationSchema={validationSchema}
        onSubmit={(values) =>
          investmentTenure
            ? investmentTenureStore.updateInvestmentTenure(values)
            : investmentTenureStore.createInvestmentTenure(values)
        }
      >
        {({ values, isSubmitting }) => (
          <Form>
            <MyFormikController
              control="input"
              label="Enter Tenure"
              name="tenure"
              type="number"
            />

            <Button
              type="submit"
              variant="contained"
              fullWidth
              sx={{
                mt: 2,
              }}
            >
              {isSubmitting ? (
                <CircularProgress color="inherit" />
              ) : investmentTenure ? (
                "Modify"
              ) : (
                "Proceed"
              )}
            </Button>
          </Form>
        )}
      </Formik>
    </Box>
  );
});
